import Vue from 'vue'
import VueGoogleCharts from 'vue-google-charts'


export default Vue.use(VueGoogleCharts);